import React from 'react'
import { Button } from '../../../_components/Button'
import { history } from '../../../_helpers'
import ROUTES from '../../../_constants/routes'
import { createEmptyInvoiceSchedule } from '../../../_services/lender.service'
import { S_BlockerModal } from './BlockerModal.styles'
import { CREATE_NEW_SCHEDULE_BUTTON } from './constants'

import styled from 'styled-components'

export const S_Button = styled(Button)`
     {
        margin-top: 30px;
    }
`

export const ClientCreateScheduleModal = ({ business }) => {
  const routeToNewSchedule = async (businessId) => {
    if (businessId) {
      const schedule = await createEmptyInvoiceSchedule(businessId)

      history.push(`${ROUTES.client_invoice_submission}/${schedule.id}/upload?businessId=${businessId}`)
    }
  }
  return (
    <S_BlockerModal>
      <S_Button className={`save-client-btn`} onClick={() => routeToNewSchedule(business?.id, history)}>
        {CREATE_NEW_SCHEDULE_BUTTON}
      </S_Button>
    </S_BlockerModal>
  )
}
